<template>
    <div class="report-container">

        <!-- 主体视界 -->
        <main class="content-main">

            <!-- 1. 顶部大标题（完美复刻） -->
            <section class="title-group">
                <h1 class="main-title-text">积沙成塔</h1>
                <div class="sub-title-wrapper">
                    <span class="sprout-icon">🌱</span>
                    <h2 class="sub-title-text">听见抽青的声音</h2>
                </div>
            </section>

            <!-- 2. 诗歌信笺流（100%保留完整文案，错落有致，绝无框框） -->
            <section class="poem-body-flow">

                <!-- 第一组：时光沉淀 -->
                <!-- <div class="text-block slide-in-1">
                    <p class="prose-line">
                        上半年，你累计坚持了
                        <span class="stat-highlight-teal">
                            <span class="din-num">{{ ReportData.studate }}</span><span class="unit">天</span>
                        </span>
                    </p>
                    <p class="prose-line">
                        在知识的原野里漫步了
                        <span class="stat-highlight-teal">
                            <span class="din-num">{{ ReportData.playtime }}</span><span class="unit">小时</span>
                        </span>
                    </p>
                </div> -->

                <!-- 第二组：线上斩获 -->
                <div class="text-block pad-left-1 slide-in-2" v-if="ReportData.coursenumMon>0">
                     <p class="prose-line font-bold-orange">2026年9月</p>
                    <p class="prose-line" v-if="ReportData.coursenumMon>0 && ReportData.coursenumMon !== null">
                        你学习了
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.coursenumMon }}</span><span class="unit">门</span>
                        </span>课程，
                    </p>
                    <p class="prose-line" v-if="ReportData.coursenum>0 && ReportData.coursenum !== null">
                        完成了
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.coursenum }}</span><span class="unit">门</span>
                        </span>课程，
                    </p>
                     <p class="prose-line" v-if="ReportData.examTimes>0 && ReportData.examTimes !== null">
                        累计考试
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.examTimes }}</span><span class="unit">次</span>
                        </span>，
                    </p>
                    <p class="prose-line" v-if="ReportData.creditvalue>0 && ReportData.creditvalue">
                        并成功斩获了
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.creditvalue }}</span><span class="unit">个</span>
                        </span>学分。
                    </p>
                </div>

                <!-- 第三组：自律与震撼数据（重头戏，优雅拉大） -->
                <div class="text-block highlight-block slide-in-3" v-if="ReportData.rate1>0 && ReportData.rate1 !== null">
                    <div class="split-line"></div>
                    <p class="prose-line font-medium">你的自律与专注，</p>
                    <p class="prose-line font-medium">
                        打败了
                        <span class="stat-highlight-orange">
                            <span class="din-num massive">{{ ReportData.rate1 }}</span><span
                                class="unit-percent">%</span>
                        </span> 的同行伙伴。
                    </p>
                </div>

                <!-- 第四组：情感升华金句（原汁原味） -->
                <div class="text-block footer-motto slide-in-4">
                    <p class="motto-line emphasis">不赶路，却也从未停步，</p>
                    <p class="motto-line emphasis">这就是成长最好的状态。</p>
                </div>

            </section>

        </main>

        <!-- 纤细优雅的背景光晕轨道（不抢文案风头） -->
        <div class="elegant-glow-circle"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportPerfectPoemPage',
    props: ["ReportData"],
}
</script>

<style scoped>
/* 年度报告风格 · 学习数据巨幕页 */
.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    padding: 35px 28px;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26September/bg.png") no-repeat center / cover;
    background-size: 100px 32px, cover;
    background-color: #1a0810;
    font-family: -apple-system, "SF Pro Text", "PingFang SC", "Helvetica Neue", sans-serif;
    display: flex;
    flex-direction: column;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.report-container * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 主体容器 */
.content-main {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 26px;
    z-index: 2;
}

/* 1. 大标题 */
.title-group {
    margin-bottom: 36px;
    animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.main-title-text {
    font-size: 38px;
    font-weight: 900;
    margin: 0;
    letter-spacing: 6px;
    color: #4a9eff;
    /* background: linear-gradient(180deg, #ffffff 0%, #cdd8ff 100%); */
    /* -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent; */
    /* filter: drop-shadow(0 2px 16px rgba(160, 180, 255, 0.35)); */
}

.sub-title-wrapper {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.sprout-icon {
    font-size: 19px;
    margin-right: 8px;
}

.sub-title-text {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    color: rgba(45, 20, 5, 0.85);
    letter-spacing: 1.5px;
}

/* 2. 数据叙事流 */
.poem-body-flow {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.text-block {
    position: relative;
}

.pad-left-1 {
    padding-left: 20px;
}

.prose-line {
    font-size: 18px;
    line-height: 1.7;
    margin: 0;
    color: rgba(45, 20, 5, 0.78);
    letter-spacing: 0.8px;
}

.font-bold-orange {
  display: inline-block;
  /* background: #f3a953; */
  font-size: 24px;
  background: rgba(91, 147, 211, 0.35);
  font-weight: 800;
  padding: 2px 12px 2px 8px;
  border-radius: 4px 12px 3px 10px / 10px 3px 12px 4px;
}

.font-medium {
    font-weight: 500;
}

/* 高光数字 */
.din-num {
    font-family: "DIN Alternate", "Helvetica Neue", Arial, sans-serif;
    font-weight: 800;
    font-size: 34px;
    margin: 0 4px;
    color: #0e6dba;
    background: rgba(91, 147, 211, 0.35);
    border-radius: 4px 12px 3px 10px / 10px 3px 12px 4px;
    /* -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6)); */
}

.unit {
    font-size: 14px;
    font-weight: 700;
    color: #4a9eff;
    -webkit-text-fill-color: #4a9eff;
}

.stat-highlight-teal {
    display: inline-block;
}

.stat-highlight-gold {
    display: inline-block;
}

/* 第三组：打败同行 */
.highlight-block {
    padding: 22px 0 6px;
}

.split-line {
    width: 48px;
    height: 2px;
    background: linear-gradient(90deg, #4a9eff, transparent);
    margin-bottom: 20px;
    border-radius: 2px;
    box-shadow: 0 0 8px rgba(74, 158, 255, 0.5);
}

.stat-highlight-orange {
    display: inline-flex;
    align-items: baseline;
}

.din-num.massive {
    font-size: 32px;
    font-weight: 900;
    line-height: 1;
     background: rgba(91, 147, 211, 0.35);
    border-radius: 4px 12px 3px 10px / 10px 3px 12px 4px;
    /* -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6)); */
    margin: 0 2px 0 6px;
}

.unit-percent {
    font-size: 22px;
    font-weight: 800;
    color: #4a9eff;
    -webkit-text-fill-color: #4a9eff;
}

/* 第四组：收尾金句 */
.footer-motto {
    margin-top: 10px;
}

.motto-line {
    font-size: 15px;
    color: rgba(45, 20, 5, 0.5);
    margin: 0 0 6px 0;
    letter-spacing: 2px;
}

.motto-line.emphasis {
    font-size: 18px;
    font-weight: 800;
    color: #2d1505;
    letter-spacing: 2px;
    margin-bottom: 0;
}

/* 背景装饰光圈 */
.elegant-glow-circle {
    position: absolute;
    width: 240px;
    height: 240px;
    right: -80px;
    bottom: 18%;
    background: radial-gradient(circle, rgba(126, 232, 214, 0.14), transparent 70%);
    border-radius: 50%;
    z-index: 1;
    pointer-events: none;
}

/* 入场动画 */
.slide-in-1 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.slide-in-2 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.15s both;
}

.slide-in-3 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.3s both;
}

.slide-in-4 {
    animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.5s both;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-12px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInBlur {
    from {
        opacity: 0;
        transform: translateY(15px);
        filter: blur(5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
        filter: blur(0);
    }
}

/* 小屏手机适配 */
@media screen and (max-height: 670px) {
    .main-title-text {
        font-size: 30px;
    }

    .title-group {
        margin-bottom: 22px;
    }

    .poem-body-flow {
        gap: 16px;
    }

    .prose-line {
        font-size: 16px;
    }

    .din-num {
        font-size: 28px;
    }

    .din-num.massive {
        font-size: 32px;
    }

    .motto-line.emphasis {
        font-size: 16px;
    }
}

/* PC端适配 */
@media screen and (min-width: 1024px) {
    .report-container {
        background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26September/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, cover;
        width: 100% !important;
        height: 100vh !important;
        padding: 60px 10%;
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }

    .content-main {
        max-width: 520px;
        margin: 0 auto;
        justify-content: center;
        padding-top: 0;
    }
    .unit {
        font-size: 24px;
        font-weight: 700;
        color: #4a9eff;
        -webkit-text-fill-color: #4a9eff;
    }
    .din-num {
        margin-bottom: 36px;
        animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .din-num {
        font-size: 40px;
    }

    .din-num.massive {
        font-size: 64px;
    }

    .elegant-glow-circle {
        width: 380px;
        height: 380px;
        right: 6%;
    }
}
</style>